<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="35%"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="200px"
    >
      <el-form-item
        label="用户端返点完成率显示开关"
        prop="rebateCompleteRateState"
      >
        <el-switch
          v-model="formData.rebateCompleteRateState"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event)"
        ></el-switch>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button
          :disabled="formLoading"
          type="primary"
          @click="submitForm"
          v-if="formType != 'view'"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">
          {{ formType == "view" ? "关 闭" : "取 消" }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
  <script>
import { Message } from "element-ui";
import {
  factoryManageParamView,
  factoryManageParamUpdate,
} from "@/api/factory/manage";

import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
export default {
  name: "index",
  components: {},

  data() {
    return {
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {
        rebateCompleteRateState: 1,
      },
      formRules: {
        // rebateCompleteRateState: [
        //   { required: true, message: "请输入", trigger: "blur" },
        // ],
      },
    };
  },
  created() {},
  methods: {
    /** 打开弹窗 */
    async open(type, row) {
      this.resetForm();
      this.dialogVisible = true;
      this.dialogTitle = "盘厂参数显示设置";
      this.formType = type;
      // 修改时，设置数据

      this.formLoading = true;
      const res = await factoryManageParamView();
      this.formData = {
        ...res.data,
      };
      this.formLoading = false;
    },
    async submitForm() {
      // 校验表单
      if (!this.$refs.formRef) return;
      const valid = await this.$refs.formRef.validate();
      if (!valid) return;
      try {
        const newData = {
          ...this.formData,
        };

        this.formLoading = true;
        const res = await factoryManageParamUpdate(newData);
        if (res.code == 200) {
          Message.success("修改成功");
        }
        this.dialogVisible = false;
        // 发送操作成功的事件
        this.$emit("success");
        this.formLoading = false;
      } catch (e) {
        this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
    },

    // 重置
    resetForm() {
      this.formData = {
        rebateCompleteRateState: 1,
      };
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSwitch(value) {
      console.log(value);
    },
  },
};
</script>
  <style scoped >
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
/deep/.el-input__inner {
  text-align: left;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
</style>
  